import React from 'react'
import { NavLink } from 'react-router-dom'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux'


const Navbar2 = (props) => {
  const { auth, user, points } = props;
  // console.log(auth);
  const links = auth.uid && user ? <SignedInLinks profile={user} auth={auth} points={points} /> : <SignedOutLinks />;

  return (
    <div className="topNav" style={{"position":"relative", "zIndex":"0"}}>
    <nav className="testNav">
      <div className="flexNav">
        <div>
        </div>
        <div>
          <NavLink to='/' className="title">kilRVA</NavLink>
        </div>
        
      </div>
    </nav>
    
    </div>
  )
}

const mapStateToProps = (state) => {
  // console.log(state);
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return{
    auth: state.firebase.auth,
    points: state.firestore.data.points,
    user
  }
}

export default connect(mapStateToProps)(Navbar2)
